
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker } from '@/components';
import { AppFileUpload, AppImageHolder } from '@/components';
import { useDuplicateItemEdit } from '@/modules/duplicate/item/model/edit';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.ITEM.EDIT,
    components: {
        AppFormRow,
        AppInput,
        AppCard,
        AppButton,
        AppSelect,
        AppDateTimePicker,
        AppFileUpload,
        AppImageHolder
    },
    setup() {
        const { model, v$, gameMatchOptions, timeUnits, actions } = useDuplicateItemEdit();

        return { v$, model, actions, gameMatchOptions, timeUnits };
    }
});
